module.exports = __webpack_public_path__ + "img/zanwufajieqian.e379bf97.png";